import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getCourseEnrollments(_obj, params) {
    const res = await axios.get(`api/lms/course-log/`, { params });
    return res.data;
  },
  async getCourseEnrollment(_obj, id) {
    const res = await axios.get(`api/lms/course-log/${id}/`);
    return res.data;
  },
  async getAcademicTranscript(_obj, params) {
    const res = await axios.get(`api/lms/chapter-progress/academic-transcript-by-school/`, { params });
    return res.data;
  },
  async createCourseEnrollment(_obj, data) {
    const res = await axios.post(`api/lms/course-log/`, data);
    return res.data;
  },
  async updateCourseEnrollment(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/course-log/${id}/`, data);
    return res.data;
  },
  async deleteCourseEnrollment(_obj, id) {
    const res = await axios.delete(`api/lms/course-log/${id}/`);
    return res.data;
  },
  async getCertificateEligibleCourses(_obj, params) {
    const res = await axios.get(`api/lms/course-certificates/eligible-courses/`, { params });
    return res.data;
  },
  async getCourseCertificates(_obj, params) {
    const res = await axios.get(`api/lms/course-certificates/`, { params });
    return res.data;
  },
  async generateCourseCertificate(_obj, data) {
    const res = await axios.post(`api/lms/course-certificates/generate/`, data);
    return res.data;
  },
};

export const courseEnrollments = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
